<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="prodAbnormal"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
        @select="selectHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="发生日期">
              <el-date-picker
                  v-model="filter.statDate"
                  type="date"
                  style="width: 180px"
                  value-format="yyyy-MM-dd"
                  clearable
                  placeholder="请选择日期"/>
            </el-form-item>
            <el-form-item label="产线编码">
              <el-input v-model.trim="filter.lineCode" placeholder="请输入产线编码" clearable/>
            </el-form-item>
            <el-form-item label="工单号">
              <el-input v-model.trim="filter.workOrderNo" placeholder="请输入工单号" clearable/>
            </el-form-item>
            <el-form-item label="异常类型">
              <el-select v-model="filter.abnormalType" clearable placeholder="请选择异常类型" style="width:160px">
                <el-option label="全部" value=""/>
                <el-option label="设备故障" :value="1"/>
                <el-option label="物料异常" :value="2"/>
                <el-option label="质量批量不良" :value="3"/>
                <el-option label="工装夹具损坏" :value="4"/>
                <el-option label="人员短缺" :value="5"/>
                <el-option label="安全隐患" :value="6"/>
                <el-option label="能源" :value="7"/>
                <el-option label="工艺图纸" :value="8"/>
                <el-option label="设计变更" :value="9"/>
                <el-option label="其他" :value="10"/>
              </el-select>
            </el-form-item>
            <el-form-item label="单据状态">
              <el-select v-model="filter.billStatus" clearable placeholder="请选择状态" style="width:140px">
                <el-option label="全部" value=""/>
                <el-option label="已上报待派工" :value="1"/>
                <el-option label="处理中" :value="2"/>
                <el-option label="待验收关闭" :value="3"/>
                <el-option label="已闭环" :value="4"/>
                <el-option label="作废" :value="9"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
    <prod-abnormal-edit ref="prodAbnormalEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import ProdAbnormalEdit from "./ProdAbnormalEdit";

  export default {
    name: "ProdAbnormalList",
    components: { ProdAbnormalEdit, ViewTable },
    data() {
      return {
        limits: {
          addAuth: this.$auth(4),
          editAuth: this.$auth(7),
          delAuth: this.$auth(9),
        },
        filter: {
          statDate: "",
          lineCode: "",
          workOrderNo: "",
          abnormalType: "",
          billStatus: "",
        },
        columnsProperty: [
          { tooltip: true, key: "abnormalTitle", width: 160 },
          { tooltip: true, key: "lineCode", align: "center", width: 100 },
          { tooltip: true, key: "statDate", align: "center", width: 110 },
          { tooltip: true, key: "workOrderNo", align: "center", width: 120 },
          { key: "abnormalType", align: "center", width: 100 },
          { key: "abnormalLevel", align: "center", width: 90 },
          { tooltip: true, key: "reportEmpName", align: "center", width: 100 },
          { tooltip: true, key: "startTime", align: "center", width: 150 },
          { tooltip: true, key: "endTime", align: "center", width: 150 },
          { key: "stopHour", align: "center", width: 110 },
          { key: "billStatus", align: "center", width: 100 },
          { tooltip: true, key: "createTime", align: "center", width: 150 },
          { key: "action", width: 200, slot: "action", fixed: "right" },
        ],
      };
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.prodAbnormalEdit.open(row);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "prodAbnormal", row.id).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
    },
  };
</script>
